import React, { useState, useEffect } from 'react'
import './Viewbar.css'
import NewDocument from './rightbar components/NewDocument'
import { useDispatch, useSelector } from 'react-redux';
import Archive from './rightbar components/Archive';
import $ from "jquery";
import Obsolete from './rightbar components/Obsolete';
import Revise from './rightbar components/Renew';
import Properties from './rightbar components/Properties';
import * as actions from '../../../helpers/Rightbar_action';
import Search from './rightbar components/Search';
import { rightBarClose } from '../../../redux/action/Action';
import Notifications from './rightbar components/Notifications';
import UploadDocument from './rightbar components/UploadDocument';

export default function Viewbar() {

    const dispatch = useDispatch();
    const {rightbarOpen, rightbarType, rightbarId} = useSelector(state=> ({ 
        rightbarOpen : state.documentReducer.rightbarOpen, 
        rightbarType : state.documentReducer.rightbarType,
        rightbarId : state.documentReducer.rightbarId
    }));
 const closeRightPanel = () => {
    dispatch(rightBarClose())
    $("body").removeClass("scrollhide")
 }

  return (
     <>
     { rightbarOpen && <div className='viewbar-overlay' onClick={rightbarType === actions.NEW_DOCUMENT || rightbarType === actions.UPLOAD_DOCUMENT ||rightbarType === actions.SEARCH_BAR || rightbarType === actions.ARCHIVE || rightbarType === actions.REVISE || rightbarType === actions.UNOBSOLETE || rightbarType === actions.OBSOLETE ? null : closeRightPanel}></div>}
        {
        rightbarType === actions.NEW_DOCUMENT ?
            <NewDocument rightbarOpen={rightbarOpen} /> :

        rightbarType === actions.UPLOAD_DOCUMENT ?
            <UploadDocument rightbarOpen={rightbarOpen} /> :

        rightbarType === actions.SEARCH_BAR ?
            <Search rightbarOpen={rightbarOpen} /> :
        
        rightbarType === actions.ARCHIVE ?
            <Archive rightbarOpen={rightbarOpen} rightbarId={rightbarId} /> :

        rightbarType === actions.OBSOLETE || rightbarType === actions.UNOBSOLETE ?
            <Obsolete rightbarOpen={rightbarOpen} rightbarId={rightbarId} rightbarType={rightbarType} /> :
        
        rightbarType === actions.REVISE ?
            <Revise rightbarOpen={rightbarOpen} rightbarId={rightbarId} /> : 
            
        rightbarType === actions.PROPERTIES ?
            <Properties rightbarOpen={rightbarOpen} rightbarId={rightbarId} /> :

        rightbarType ===  actions.NOTIFICATIONS ?
            <Notifications rightbarOpen={rightbarOpen} rightbarId={rightbarId} /> : ''
    }

    
  </>
  )
}
